import CustomSelect from "./CustomSelect";
import deleteIcon from '../assets/icons/deleteRole.svg';

export const ApplicableCurrenciesTable = ({
  currencies = [],
  onAddCurrency,
  onToggleActive,
  onDeleteCurrency, 
  currencyOptions = []
}) => (
  <div className="applicable-currency-wrapper">
    <h6 className="normal-button-text-regular">Applicable Currencies</h6>
 <div className='table-header'></div>
    <table className="currency-table">
      <thead>
        <tr>
          <th>Currency Code</th>
          <th>Currency Name</th>
          <th style={{ textAlign: "center", width: 100 }}>Active</th>
          <th style={{ textAlign: "center", width: 80 }}>Remove</th> 
        </tr>
      </thead>

      <tbody>
        {currencies.map((c,index) => (
          <tr key={c.currencyCode} className={!Number(index % 2) ? "tableEvenRowClass" : "tableRowClass"} style={{ color: "#fff" }}
>
            <td>{c.currencyCode}</td>
            <td>{c.currencyName}</td>
            <td style={{ textAlign: "center" }}>
                <div className={`dialog__container_item input-container`}>
            <div className={`alignItemsCenter justifyContentCenter dialog__description__checkbox`}>
              <input
                type="checkbox"
                checked={!!c.active}
                onChange={() => onToggleActive(c.currencyCode)}
              />
            </div>
            </div>
            </td>
            <td style={{ textAlign: "center" }}>
              <button
                type="button"
                className="delete-btn"
                title="Remove"
                onClick={() => onDeleteCurrency(c.currencyCode)}
              >
              <img className='aircraft-actions' alt='delete'   src={deleteIcon}/>
              </button>
            </td>
          </tr>
        ))}

        <tr className="add-currency-table-row">
          <td>
              <CustomSelect
              placeHolder="Select Currency"
              options={currencyOptions}
              onChange={onAddCurrency}
              menuPortalTarget={null}
              menuPosition="absolute"
            />
          </td>
          <td />
          <td />
          <td />
        </tr>
      </tbody>
    </table>
  </div>
);
